import { render, staticRenderFns } from "./MedicalContactProviderModal.vue?vue&type=template&id=2dfe47d8&scoped=true"
import script from "./MedicalContactProviderModal.vue?vue&type=script&lang=js"
export * from "./MedicalContactProviderModal.vue?vue&type=script&lang=js"
import style0 from "./MedicalContactProviderModal.vue?vue&type=style&index=0&id=2dfe47d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe47d8",
  null
  
)

export default component.exports